import { render, staticRenderFns } from "./IntegrationForm.vue?vue&type=template&id=0dcfc1bf&scoped=true&"
import script from "./IntegrationForm.vue?vue&type=script&lang=js&"
export * from "./IntegrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcfc1bf",
  null
  
)

export default component.exports